export function createEraseSession() {
    const ids = new Set();
    return {
        get size() {
            return ids.size;
        },
        add(drawingId) {
            ids.add(drawingId);
        },
        has(drawingId) {
            return ids.has(drawingId);
        },
        clear() {
            ids.clear();
        },
        finish(drawings) {
            const deleted = drawings.filter((drawing) => ids.has(drawing.id)).map((drawing) => drawing.id);
            const remaining = drawings.filter((drawing) => !ids.has(drawing.id));
            return { remaining, deleted };
        },
    };
}
